<template>
  <tab-layout>
    <li slot="tabHeading" class="nav-item">
      <a :class="['nav-link', selectedTab === 'details' ? 'active' : '']" href @click.prevent="selectedTab = 'details'" id="details-tab" data-toggle="tab" role="tab" aria-controls="details" :aria-selected="selectedTab === 'details' ? 'true' : 'false'">Details</a>
    </li>
    <member-profile-details :memberDetails="memberDetails" v-if="selectedTab === 'details'" slot="tabContent" class="tab-pane row mx-0 show active" id="details" role="tabpanel" aria-labelledby="details-tab" />
  </tab-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import tabLayout from '@/components/TabLayout'
import GETSTORE from '@/store/memberProfileStore.js'
import memberProfileDetails from '@/views/Admin/Tabs/MemberDetails'

export default {
  name: 'AdminProfileChild',
  props: ['details'],
  mixins: [GETSTORE],
  components: {
    'tab-layout': tabLayout,
    'member-profile-details': memberProfileDetails
  },
  data() {
    return {
      child: true,
      selectedTab: 'details'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Admin/Profile/AdminProfileChild.vue